import moment from 'moment';
import { HttpClient } from '@/shared/lib/http-client';

export const createNewTask = async ({ name, description = null, finishDate = new Date() }) => {
  const response = await HttpClient.post('/tasks', {
    name: name,
    description: description,
    finish_date: moment(finishDate).format('DD-MM-YYYY'),
  });

  return response.data?.data;
};
